var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-tab",class:['tab-list' + _vm.list.length,{'tab':_vm.model == 1},
{'zIndex-high':_vm.zIndexHigh,'fixed': _vm.isFixed,'avoid-header':_vm.isAvoidHeader}]},_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"tab-item",class:[
    {'tab-drop': _vm.model == 2},
    {'drop': _vm.model == 2 && item.selected},
    {'active': _vm.model == 1 && item.selected}],on:{"click":function($event){_vm.switchTab(item.id)}}},[_vm._v(_vm._s(item.name))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5429d60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/head-tab.vue
// module id = /JOz
// module chunks = 0